import request from "@/utils/request";

export default function agentRemoteDoorOpen(ids) {
  return request.get(`/device/accessControllerDevice/agentRemoteDoorOpen/${ids}`);
}
